export default [

    {
        path: '',
        name: 'pesquisa-de-campo',
        redirect: { name: 'pesquisa-de-campo--home' },
    },

    {
        path: 'home',
        name: 'pesquisa-de-campo--home',
        component: () => import('@/aplicacao/modulos/pesquisa-de-campo/_Home'),
        meta: { autenticacao: true, permissao: 'ROLE__PESQUISA_DE_CAMPO' },
    },

    {
        path: 'criar-pesquisa',
        name: 'pesquisa-de-campo--gestao-criar-pesquisa',
        component: () => import('@/aplicacao/modulos/pesquisa-de-campo/gestao/Formulario'),
        meta: { autenticacao: true, permissao: 'ROLE__PESQUISA_DE_CAMPO__GERENCIAR' },
    },

    {
        path: 'editar-pesquisa/:id',
        name: 'pesquisa-de-campo--gestao-editar-pesquisa',
        component: () => import('@/aplicacao/modulos/pesquisa-de-campo/gestao/Formulario'),
        meta: { autenticacao: true, permissao: 'ROLE__PESQUISA_DE_CAMPO__GERENCIAR' },
    },

    {
        path: 'consultar-pesquisa/:id',
        name: 'pesquisa-de-campo--gestao-consultar-pesquisa',
        component: () => import('@/aplicacao/modulos/pesquisa-de-campo/gestao/Consulta'),
        meta: { autenticacao: true, permissao: 'ROLE__PESQUISA_DE_CAMPO__GERENCIAR' },
    },

    {
        path: 'historico',
        name: 'pesquisa-de-campo--gestao-historico',
        component: () => import('@/aplicacao/modulos/pesquisa-de-campo/gestao/Historico'),
        meta: { autenticacao: true, permissao: 'ROLE__PESQUISA_DE_CAMPO__GERENCIAR' },
    },

    {
        path: 'minhas-pesquisas',
        name: 'pesquisa-de-campo--gestao-minhas',
        component: () => import('@/aplicacao/modulos/pesquisa-de-campo/gestao/Minhas'),
        meta: { autenticacao: true, permissao: 'ROLE__PESQUISA_DE_CAMPO__GERENCIAR' },
    },

    {
        path: 'rascunhos-pesquisas',
        name: 'pesquisa-de-campo--gestao-rascunhos',
        component: () => import('@/aplicacao/modulos/pesquisa-de-campo/gestao/Rascunhos'),
        meta: { autenticacao: true, permissao: 'ROLE__PESQUISA_DE_CAMPO__GERENCIAR' },
    },

    {
        path: 'relatorios/geral',
        name: 'pesquisa-de-campo--gestao-relatorio-geral',
        component: () => import('@/aplicacao/modulos/pesquisa-de-campo/gestao/relatorios/Geral'),
        meta: { autenticacao: true, permissao: 'ROLE__PESQUISA_DE_CAMPO__GERENCIAR' },
    },

    {
        path: 'pesquisas-disponiveis',
        name: 'pesquisa-de-campo--resposta-disponiveis',
        component: () => import('@/aplicacao/modulos/pesquisa-de-campo/resposta/Disponiveis'),
        meta: { autenticacao: true, permissao: 'ROLE__PESQUISA_DE_CAMPO__RESPONDER' },
    },

    {
        path: 'pesquisas-respondidas',
        name: 'pesquisa-de-campo--resposta-respondidas',
        component: () => import('@/aplicacao/modulos/pesquisa-de-campo/resposta/Respondidas'),
        meta: { autenticacao: true, permissao: 'ROLE__PESQUISA_DE_CAMPO__RESPONDER' },
    },

    {
        path: 'respondendo-respostas',
        name: 'pesquisa-de-campo--resposta-rascunhos',
        component: () => import('@/aplicacao/modulos/pesquisa-de-campo/resposta/Respondendo'),
        meta: { autenticacao: true, permissao: 'ROLE__PESQUISA_DE_CAMPO__RESPONDER' },
    },

    {
        path: 'responder-pesquisa/:id/:rId?',
        name: 'pesquisa-de-campo--resposta-responder-formulario',
        component: () => import('@/aplicacao/modulos/pesquisa-de-campo/resposta/Formulario'),
        meta: { autenticacao: true, permissao: 'ROLE__PESQUISA_DE_CAMPO__RESPONDER' },
    },

    {
        path: 'consultar-resposta/:id',
        name: 'pesquisa-de-campo--resposta-consultar',
        component: () => import('@/aplicacao/modulos/pesquisa-de-campo/resposta/Consulta'),
        meta: { autenticacao: true, permissao: 'ROLE__PESQUISA_DE_CAMPO' },
    },

]
